import type { EHumanReviewTab, THumanReviewDetail } from './human-review-requests.type'
import HumanReviewPatientHeader from './human-review-patient-header.component'
import HumanReviewPatientFooter from './human-review-patient-footer.component'
import { ProblemContent } from './problems/problem-content.component'

type Props = {
  humanReviewDetail: THumanReviewDetail
  activeSubject: EHumanReviewTab
  onTabChange: (tab: EHumanReviewTab) => void
}

const HumanReviewPatientPanel = ({ humanReviewDetail, activeSubject, onTabChange }: Props) => (
  <div className="c-w-full c-flex c-flex-col c-overflow-auto">
    <HumanReviewPatientHeader
      humanReviewDetail={humanReviewDetail}
      activeSubject={activeSubject}
      onTabChange={onTabChange}
    />
    <hr className="c-border-grey-300" />
    <ProblemContent humanReviewDetail={humanReviewDetail} activeSubject={activeSubject} />
    <hr className="c-border-grey-300" />
    <HumanReviewPatientFooter humanReviewDetail={humanReviewDetail} />
  </div>
)

export default HumanReviewPatientPanel
